import Metapod from './Metapod';

export default Metapod;



/** WEBPACK FOOTER **
 ** ./source/011-metapod/index.js
 **/